import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal,
  viewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  CtBatchApiService,
  DocumentClassKey,
  ClaimsToastService,
} from '@ps-gui/claims-terminal-shared';
import { map, switchMap, tap } from 'rxjs';
import { KeyValuePipe, NgClass } from '@angular/common';
import { CtBatchExtractionApiService } from '../../service/api/ct-batch-extraction-api.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { JsonViewComponent } from '../../3rdparty/nxt-json-view/json-view/json-view.component';

@Component({
  templateUrl: './extraction-result.component.html',
  imports: [KeyValuePipe, NgClass, JsonViewComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExtractionResultComponent {
  private readonly extractionApi = inject(CtBatchExtractionApiService);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly ctBatchApi = inject(CtBatchApiService);
  private readonly toastService = inject(ClaimsToastService);

  private readonly jsonView = viewChild<JsonViewComponent>('jsonView');

  protected readonly extractionResults = toSignal(
    this.activatedRoute.params.pipe(
      map((params) => params['batchId']),
      switchMap((batchId) => this.ctBatchApi.getCtBatch(batchId)),
      switchMap((batch) => this.extractionApi.loadExtractionDataByDocumentId(batch)),
      tap({
        error: () =>
          this.toastService.error('Daten konnten nicht geladen werden. Stimmt die *CT-BATCH*-id?'),
      }),
    ),
  );

  protected readonly selectedExtractionParameters = signal<
    undefined | { documentId: string; documentClass: DocumentClassKey }
  >(undefined);

  protected readonly selectedExtractionResult = computed(() => {
    const results = this.extractionResults();
    if (!results) return;

    const parameters = this.selectedExtractionParameters();
    if (!parameters) return undefined;

    return results[parameters.documentId][parameters.documentClass];
  });

  selectParameters(documentId: string, documentClass: string) {
    this.selectedExtractionParameters.set({
      documentId,
      documentClass: documentClass as DocumentClassKey,
    });
  }

  protected expandAll() {
    this.jsonView()?.expandTo(1000);
  }

  protected collapseAll() {
    this.jsonView()?.collapseTo(0);
  }
}
